import React from 'react';
export const ActionsSpacer = ({ onClick, noHover }) => {
    return (React.createElement("span", { style: { flexGrow: 1, height: '100%', cursor: noHover ? 'auto' : 'pointer' }, className: "spacer", onClick: onClick }));
};
// The Toolbar only recognizes spacers with the 'ToolbarSpacer' displayName
ActionsSpacer.displayName = 'ToolbarSpacer';
